import React from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { Box, Typography, Link } from "@bca/ui-library";

import StarRating from "./StarRating";
import { formatMoney } from "../utils/formatMoney";
import { IProductPushable } from "../common/analytics/analytics.types";
import analytics from "../common/analytics/analytics";
import VehicleDetailsAnalytics from "../analytics/VehicleDetailsAnalytics.type";

const StyledLink = styled(Link)`
  ${css({
    fontSize: "body-small",
    zIndex: "1",
  })}
`;

const pushHPIAnalytics = (vehicleAnalytics: VehicleDetailsAnalytics) => {
  analytics.push<IProductPushable>({
    event: {
      name: "click",
      category: "link",
      label: "hpi-check",
      action: "navigate",
      section: "card",
    },
    product: {
      vehicle: [vehicleAnalytics],
    },
  });
};

const HPISpecCheck: React.FunctionComponent<{
  starRating?: number | null;
  price: number | null;
  anchorLink?: string;
  vehicleAnalytics: VehicleDetailsAnalytics;
}> = ({ starRating, price, anchorLink, vehicleAnalytics }) => {
  if (price === null || price === undefined || !Boolean(starRating)) {
    return null;
  }

  return (
    <>
      <Box display="flex" justifyContent="space-between" mb="6px">
        <StarRating rating={starRating.toFixed(1)} />
        <Typography
          variant="body-small"
          color="grey-blue"
          my="0px"
          ml="8px"
        >{`${formatMoney(price)} extras`}</Typography>
      </Box>
      {anchorLink && (
        <StyledLink
          href={anchorLink}
          color="primary-light-blue"
          underline="always"
          id="#hpi-spec-check-table"
          target="_blank"
          onClick={() => pushHPIAnalytics(vehicleAnalytics)}
        >
          HPI Spec Check
        </StyledLink>
      )}
    </>
  );
};

export default HPISpecCheck;
